export enum BANNER_TYPE {
    KYCBANNER = "KYCBANNER",
    IMAGEBANNER = "IMAGEBANNER",
}

export interface BannerData {
    id: string;
    cta?: {
        link: string;
        type: string;
        text?: string;
    };
    title?: string;
    description?: string;
    backgroundImage: string;
    backgroundColor?: string;
    aspectRatio?: number;
    bannerType: BANNER_TYPE;
    bannerId?: string;
    frequencyCount?: number;
    enabled?: boolean;
    disabledText?: string;
}
